import Vue from "vue";
import Vuex from "vuex";
import ApiService from "../common/api.service";
import JwtService from "../common/jwt.service";

import homeStore from "./homeStore";
import usersStore from "./usersStore";
import skillCourtStore from "./skillCourtStore";

Vue.use(Vuex, ApiService);

export default new Vuex.Store({
  modules: {
    usersStore,
    skillCourtStore,
    homeStore
  },

  state: {
    counter: 0,
    users: {},
    token: "",
    isAuthenticated: !!JwtService.getToken(),
    currentUser: {}
  },

  getters: {
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
    takeCurrentUser(state) {
      return state.currentUser;
    }
  },

  actions: {
    checkAuth(context) {
      const id = window.localStorage.getItem("USER_ID");
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.get(`users/${id}`)
          .then(({ data }) => {
            // console.log("DATA CJECK => ", data.data);
            let checkUser = false;

            if (data.data.courts.length > 0) {
              context.commit("setUser", data);
              checkUser = true;
            } else if (data.data.is_admin === 1) {
              context.commit("setUser", data);
              checkUser = true;
            }

            if (!checkUser) {
              context.commit("logOut");
            }
          })
          .catch(() => {
            context.commit("logOut");
          });
      } else {
        context.commit("logOut");
      }
    },
    async logIn(context, credentials) {
      try {
        ApiService.setBaseUrl();
        const { data } = await ApiService.post("auth/login/", credentials);
        window.localStorage.setItem("USER_ID", data.user.id);
        if (data.user.courts.length > 0) {
          context.commit("setAuth", data);
        } else if (data.user.is_admin === 1) {
          context.commit("setAuth", data);
        }
      } catch (e) {
        console.log(e);
      }
    }
  },
  mutations: {
    setAuth(state, data) {
      // console.log("MUT TOKEN => ", data);
      state.token = data.token;
      state.isAuthenticated = true;
      state.currentUser = data.user;
      JwtService.saveToken(data.token);
      state.counter = 1;
    },
    save_check_login() {
      this.$store.state.counter = 1;
    },
    logOut(state) {
      state.isAuthenticated = false;
      state.currentUser = {};
      JwtService.destroyToken();
    },
    setUser(state, data) {
      state.isAuthenticated = true;
      state.currentUser = data.data;
      state.errors = [];
    }
  }
});
